export const Default = {
    pageSize : 10,
}